import { StringUtils } from '@/common/utils/string';
import { IEstablishment } from './establishments.types';

export const findEstablishment = (item: IEstablishment, filter: string) => {
  const itemText = StringUtils.normalizeString(
    [
      item?.name,
      item?.address.addressLine1,
      item?.address.addressLine2,
      item?.address.zipCode,
      item?.address.city,
    ].join(' ')
  );

  const filterParts = StringUtils.normalizeString(filter).match(/(\w+)/g);
  if (filterParts !== null) {
    return filterParts.every((text) => itemText.includes(text));
  }

  return true;
};
